export const MAX_FILE_SIZE = 5242880; // 5 MB
export const ACCEPTED_FILE_FORMATS = {
  'image/*': ['png', 'gif', 'jpeg', 'jpg'],
};
